import { useQuery } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

/**
 * The vehicle's history, from GET /vehicle-history/vehicle/:vehicleId for
 * every member. Asked for only while `enabled`: the call screen draws it in
 * a sheet, and fetching every change on every call opened would be a
 * request nobody looks at.
 */
export function useVehicleHistory(
  vehicleId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const { getAccessTokenSilently } = useHybridAuth();
  return useQuery({
    queryKey: ['vehicleHistory', vehicleId],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      return driverApi.getVehicleHistory(vehicleId!);
    },
    enabled: enabled && !!vehicleId,
  });
}
